module.exports = __webpack_public_path__ + "img/ss_pink-02.05350716.jpg";